import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

interface KilometerValueProps {
    value?: number;
    className?: string;
}

export const KilometerValue: React.FC<KilometerValueProps> = ({ value, className = '' }) => {
    const formattedMileage =
        typeof value === 'number' ? (
            <>
                <FormattedNumber value={Math.round(value)} />{' '}
                <FormattedMessage id="intl-msg:vehicle-diagnostics.unit.kilometers" />
            </>
        ) : (
            '-'
        );

    return <span className={`KilometerValue ${className}`}>{formattedMileage}</span>;
};

export default KilometerValue;
